import React, { useState } from 'react'
import './css/setting-nav.css'
// export default function Sidebar() {


interface navItem {
    state: string,
    name: string,
    path?: string,
    className?: string,
    key?: string
}

interface Props {
    returningUser?: boolean,
    navContent: navItem[],
    handleClick: (index: number, key?: string) => void
}

export default function SettingsNav(props: Props) {
    const { handleClick, navContent } = props

    const [navBarContentObj, setnavBarContentObj] = useState(() => navContent)


    const handleClickFnc = (indexParam: number, key: string = '') => {
        setnavBarContentObj(prev => {
            const newElems = prev.map((elem, i) => {
                if(i === indexParam){
                    elem = {...elem, "state":"settings-active"}
                    return elem
                }else {
                    elem = {...elem, "state":"settings-inactive"}
                    return elem
                }
            })
            return newElems
        })
        handleClick(indexParam, key);
    }

    // const handleClickFnc = (nm:string) => props.name(nm)
    return (
        <>

            <nav className="setttings-nav">

                {navBarContentObj.map((navElem, index) =>
                     <div onClick={() => handleClickFnc(index, navElem?.key)} className={`settings-nav-item${navElem?.className? ' ' + navElem.className : ''}`} key={index}>
                        {/* <div className="settings-nav-item"> */}
                            {navElem.name}
                            <div className={`bottom-style ${navElem.state}`}></div>
                        {/* </div> */}
                     </div>
                )}
            </nav>
        </>
    )
}
